<template>
    <div class="search-view">
        <van-search v-model="searchKey" show-action placeholder="請輸入關鍵字" @search="onSearch">
            <div slot="action" @click="onSearch">搜尋</div>
        </van-search>
        <div class="history-view">
            <div class="history-title">
                <h4>最近搜尋</h4>
                <span @click="onClear">清空紀錄</span>
            </div>
        </div>
        <van-tag @click="onHistoryItem" round v-for="(item,index) in historyList" :key="index">{{item}}</van-tag>
        <!-- 搜索詳情 -->
        <searchDetailView v-if="searchDetailShow" @onBack='onDetailHide' :searchDataList='searchDataList'></searchDetailView>
    </div>
</template>

<script>
    import { Search, Tag, Toast } from 'vant';
    import searchDetailView from "../searchDetailView/searchDetailView.vue";
    export default {
        name: "searchView",
        components: {
            [Search.name]: Search,
            [Tag.name]: Tag,
            [Toast.name]: Toast,
            searchDetailView,
        },
        data() {
            return {
                title: "搜尋",
                navViewShow: false,
                searchKey: '',
                historyList: [
                    '明月',
                    '海昌',
                    '隐形眼镜'
                ],
                searchDetailShow: false,
                searchDataList: null,
            };
        },
        created() {
            // console.log(this.title);
            // 創建時，發送標題
            this.$emit("onTitle", this.title);
            this.$emit("onNavShow", this.navViewShow);
        },
        methods: {
            onSearch: function () {
                //如果有值點擊出現搜尋結果
                if (this.searchKey) {
                    this.searchDetail()
                    this.historyList.push(this.searchKey)
                }
            },
            onClear: function () {
                this.historyList = []
            },
            onHistoryItem: function (item) {
                this.searchKey = item
                this.searchDetail()
            },
            onDetailHide: function () {
                this.searchDetailShow = false
            },
            closeLoading: function () {
                //顯示搜尋詳情內容
                this.searchDetailShow = true
            },
            searchDetail: function () {
                //加載提示(加載數據)
                Toast.loading({
                    mask: true,
                    message: '加載中...',
                    duration: 0,
                    onClose: this.closeLoading//關閉後的回調
                });
                var that = this
                console.log('搜尋關鍵字:' + this.searchKey)
                //獲取數據
                //傳遞參數:搜索的關鍵字searchKey
                this.$ajax.get('/json/search-detail.json')
                    .then(function (response) {
                        //數據已經獲取
                        console.log(response.data)
                        that.searchDataList = response.data.list
                        //關閉提示
                        Toast.clear()
                    })
            }
        }
    };
</script>

<style lang='scss'>
    .search-view {
        background-color: #f2f2f2;
        .history-view {
            padding: 0 20px;
            .history-title {
                padding: 15px 0;
                overflow: hidden;
                h4 {
                    float: left;
                    font-size: 16px;
                }
                span {
                    color: red;
                    font-size: 16px;
                    float: right;
                }
            }
        }
        .van-tag {
            margin: 5px 10px;
            padding: 5px 10px;
            font-size: 14px;
        }
    }
</style>
